// free gift 

$('#free-gift-drawer .thb-close, .gift-overlay').click(function(){
    $('#free-gift-drawer').removeClass('active');
  $('.gift-overlay').removeClass('active');
});
  
function updatedFreeProduct() {
  let amount = $('.free-gift-drawer').data('free-product-amount');
  let minimum = Math.round(parseInt(amount, 10) * (Shopify.currency.rate || 1));
  console.log(amount);
  // Get variant IDs from buttons
  let giftIds = [];
  $('.add-btn-box').each(function() {
    giftIds.push($(this).data('product-id'));
  });
    // Get cart data
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // console.log('cart',cart);
          // let total = cart.total_price;
           let total =  parseInt(cart.total_price, 10);
          let inCart = cart.items.some(item => giftIds.includes(item.product_id));
      // console.log('total',total)
          if(total >= minimum && !inCart){
             $('.free-gift-drawer').addClass('active');
            $('.gift-overlay').addClass('active');
          }else if(inCart){
             $('.free-gift-drawer').removeClass('active');
            $('.gift-overlay').removeClass('active');
          }
          else{
            $('.free-gift-drawer').removeClass('active');
            $('.gift-overlay').removeClass('active');
          }
         
      });
}


updatedFreeProduct();

 $(document).on('click','.sizing-box .free-variant-submit', function(){
     let value = $(this).data('id');
    let button = $(this).closest('.product-information').find('.add_to_cart_button').attr('data-id',value);
    $(this).closest('.product-information').find('.free-variant_container').removeClass('active');
     $(this).closest('.free-variant_container').addClass('active');
    let button_id = $(this).closest('.product-information').find('.add_to_cart_button').attr('data-product-id',value);
    // console.log(button,button_id);
   })

// end free gift